import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';

interface OnboardingGuardState {
  isOnboarded: boolean;
  loading: boolean;
}

export function useOnboardingGuard(): OnboardingGuardState {
  const { user } = useAuth();
  const [state, setState] = useState<OnboardingGuardState>({
    isOnboarded: false,
    loading: true,
  });

  useEffect(() => {
    if (!user) {
      setState({ isOnboarded: false, loading: false });
      return;
    }

    async function fetchOnboardingStatus() {
      const { data, error } = await supabase
        .from('profiles')
        .select('onboarding_completed_at')
        .eq('id', user!.id)
        .single();

      if (error || !data) {
        setState({ isOnboarded: false, loading: false });
        return;
      }

      setState({
        isOnboarded: data.onboarding_completed_at !== null,
        loading: false,
      });
    }

    fetchOnboardingStatus();
  }, [user]);

  return state;
}
